import { DateTime } from 'luxon';

// src/helpers/reports/getReportDateTimesForPeriod.ts
var getBusinessDayTimes = (endOfBusinessDay, businessTimeZone) => {
  const cutoff = DateTime.fromISO(endOfBusinessDay, { zone: "utc" });
  const { hour, minute, second } = cutoff;
  const todayInBusinessTZ = DateTime.now().setZone(businessTimeZone);
  const todayStart = DateTime.fromObject(
    {
      year: todayInBusinessTZ.year,
      month: todayInBusinessTZ.month,
      day: todayInBusinessTZ.day,
      hour,
      minute,
      second
    },
    { zone: businessTimeZone }
  ).toUTC();
  const tomorrowEnd = todayStart.plus({ days: 1 }).minus({ minutes: 1 });
  return {
    todayStartDateTime: todayStart.toISO(),
    tomorrowEndDateTime: tomorrowEnd.toISO()
  };
};
function getReportDateTimesForPeriod(period, endOfBusinessDayTime, businessTimeZone) {
  switch (period) {
    case "custom" /* CUSTOM */: {
      const { todayStartDateTime, tomorrowEndDateTime } = getBusinessDayTimes(
        endOfBusinessDayTime,
        businessTimeZone
      );
      return {
        startDate: todayStartDateTime,
        endDate: tomorrowEndDateTime
      };
    }
    case "specific_date" /* SPECIFIC_DATE */: {
      const todayStartDateTime = (
        // today date but with time 00:00:00
        DateTime.now().startOf("day").toUTC().toISO()
      );
      return {
        startDate: todayStartDateTime,
        endDate: ""
      };
    }
    default:
      return {
        startDate: "",
        endDate: ""
      };
  }
}

export { getReportDateTimesForPeriod };
